module.exports = __webpack_public_path__ + "static/media/BI.9eb8779b.png";